import Vue from 'vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import {
Avatar,
Button,
Grid,
Icon,
List,
Pagination,
Paper,
Select,
TextField,
theme
} from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'

export default () => {
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(Avatar)
Vue.use(Button)
Vue.use(Grid)
Vue.use(Icon)
Vue.use(List)
Vue.use(Pagination)
Vue.use(Paper)
Vue.use(Select)
Vue.use(TextField)
Vue.use(theme)
}



// WEBPACK FOOTER //
// ./src/plugins/setup.js